import { Typography } from '@material-ui/core'
import React from 'react'


const Footer = () => {




  return (
    <div className="footer">
      <div className="footer-items">
        <Typography variant="subtitle1">WebApp created in Smarctic project 2021</Typography>
      </div>
    </div>

  )
}

export default Footer